import reports from '@/api/reports'
// import { mergeUserContext } from '@/store/helpers'
// import { translateIndicators } from '@/helpers/cseit'

const colorValues = require('./data/legendColors.json')

// initial state
const state = {
  rptindicatorcount: [],
  rptassessmentIndicators: [],
  rptassessmentIndicatorsByPerson: [],
  rptgeneralCounts: {
    'personCount': 0,
    'confirmedPersonCount': 0,
    'possiblePersonCount': 0,
    'cseitCount': 0,
    'cseitCountNoConcern': 0,
    'cseitCountPossibleConcern': 0,
    'cseitCountClearConcern': 0,
    'cseitCountAllPerson': 0,
    'cseitCountNoConcernPerson': 0,
    'cseitCountPossibleConcernPerson': 0,
    'cseitCountClearConcernPerson': 0,
    'assessmentCount': 0,
    'assessmentCountNotEnoughInfo': 0,
    'assessmentCountPossible': 0,
    'assessmentCountPerson': 0,
    'assessmentCountNotEnoughInfoPerson': 0,
    'assessmentCountPossiblePerson': 0
  },
  rptPersonCountsByDemographic: [],
  rptPersonCountsByDemographicError: false,
  rptpersonCountsByTime: [],
  rptpersonCountsByTimeError: false,
  rptpersonDemographicsOverTime: [],
  rptpersonDemographicsOverTimeError: false,
  allUsers: [],
  allUsersError: false,
  allOrgs: [],
  allOrgsError: false,
  allGroups: [],
  allGroupsError: false,
  allLogs: [],
  allScreenings: [],
  allScreeningsError: false,
  allLogsError: false,
  rptassessmentCountsByTime: [],
  rptcseitCountsByTime: [],
  // rptAssessmentIndicators: [],
  rptPersonDemographicsOverTimeUnconfirmed: [],
  rptPersonDemographicsOverTimeConfirmed: [],
  rptassessmentCountsByDemographic: [],
  rptcseitCountsByDemographic: [],
  rptassessmentDemographicsByTime: [],
  rptassessmentDemographicsByTimeNoInfoVictims: [],
  rptassessmentDemographicsByTimePossibleVictims: [],
  rptcseitDemographicsByTime: [],
  rptcseitDemographicsByTimeNoConcern: [],
  rptcseitDemographicsByTimePossibleConcern: [],
  rptcseitDemographicsByTimeClearConcern: [],
  rptcseitIndicators: [],
  rptLaborScreeningIndicators: [],
  rptLaborScreeningIndicatorsError: false,
  colorValues: colorValues.items,
  rptpersonDemographicsOverTimeUnconfirmedError: false,
  rptpersonDemographicsOverTimeConfirmedError: false,
  rptcseitCountsByTimeError: false,
  rptcseitCountsByDemographicError: false,
  rptcseitDemographicsByTimeError: false,
  rptcseitDemographicsOverTimeNoConcernError: false,
  rptcseitDemographicsOverTimePossibleConcernError: false,
  rptcseitDemographicsOverTimeClearConcernError: false,
  rptassessmentCountsByTimeError: false,
  rptassessmentByDemographicError: false,
  rptassessmentDemographicsByTimeError: false,
  rptassessmentDemographicsOverTimeNoInfoError: false,
  rptassessmentDemographicsOverTimePossibleError: false,
  rptassessmentIndicatorsError: false,
  rptcseitIndicatorsError: false,
  // location filters
  locationFilterOptions: [
    {
      value: 'All',
      text: 'All States'
    },
    {
      value: 'LA',
      text: 'Louisiana'
    },
    {
      value: 'TX',
      text: 'Texas'
    }
  ],
  screeningsByOrg: [],
  screeningsByOrgError: false,
  laborScreeningsByOrg: [],
  laborScreeningsByOrgError: false,
  rptLaborScreeningCountsByTime: [],
  rptLaborScreeningCountsByTimeError: false,
  rptLaborScreeningCountsByDemographic: [],
  rptLaborScreeningCountsByDemographicError: false,
  rptLaborScreeningDemographicsByTime: [],
  rptLaborScreeningDemographicsByTimeNotEnoughInfo: [],
  rptLaborScreeningDemographicsByTimeVulnerable: [],
  rptLaborScreeningDemographicsByTimeHighlyVulnerable: [],
  rptLaborScreeningDemographicsByTimeError: false
}

// getters
const getters = {
  getReportAssessmentIndicators: state => state.rptassessmentIndicators,
  getReportAssessmentIndicatorsByPerson: state => state.rptassessmentIndicatorsByPerson,
  // indicatorCount: state => state.rptindicatorcount,
  getReportPersonCountsByDemographic: state => state.rptPersonCountsByDemographic,
  getReportPersonCountsByDemographicError: state => state.rptPersonCountsByDemographicError,
  getReportPersonCountsByTime: state => state.rptpersonCountsByTime,
  getReportPersonCountsByTimeError: state => state.rptpersonCountsByTimeError,
  getReportGeneralCounts: state => state.rptgeneralCounts,
  getReportPersonDemographicsOverTime: state => state.rptpersonDemographicsOverTime,
  getAllUsers: state => state.allUsers,
  getAllUsersError: state => state.allUsersError,
  getAllOrgs: state => state.allOrgs,
  getAllOrgsError: state => state.allOrgsError,
  getGroups: state => state.allGroups,
  getGroupsError: state => state.allGroupsError,
  getAllLogs: state => state.allLogs,
  getAllLogsError: state => state.allLogsError,
  getAllScreenings: state => state.allScreenings,
  getAllScreeningsError: state => state.allScreenings,
  getReportAssessmentCountsByTime: state => state.rptassessmentCountsByTime,
  getReportCseitCountsByTime: state => state.rptcseitCountsByTime,
  getReportPersonDemographicsOverTimeUnconfirmed: state => state.rptPersonDemographicsOverTimeUnconfirmed,
  getReportPersonDemographicsOverTimeConfirmed: state => state.rptPersonDemographicsOverTimeConfirmed,
  getReportAssessmentCountsByDemographic: state => state.rptassessmentCountsByDemographic,
  getReportCseitCountsByDemographic: state => state.rptcseitCountsByDemographic,
  getReportAssessmentDemographicsByTime: state => state.rptassessmentDemographicsByTime,
  getReportAssessmentDemographicsByTimeNoInfoVictims: state => state.rptassessmentDemographicsByTimeNoInfoVictims,
  getReportAssessmentDemographicsByTimePossibleVictims: state => state.rptassessmentDemographicsByTimePossibleVictims,
  getReportCseitDemographicsByTime: state => state.rptcseitDemographicsByTime,
  getReportCseitDemographicsByTimeNoConcern: state => state.rptcseitDemographicsByTimeNoConcern,
  getReportCseitDemographicsByTimePossibleConcern: state => state.rptcseitDemographicsByTimePossibleConcern,
  getReportCseitDemographicsByTimeClearConcern: state => state.rptcseitDemographicsByTimeClearConcern,
  getReportCseitIndicators: state => state.rptcseitIndicators,
  getRptLaborScreeningIndicators: state => state.rptLaborScreeningIndicators,
  getRptLaborScreeningIndicatorsError: state => state.rptLaborScreeningIndicatorsError,
  // getColorValues: state => {
  //   return state.colorValues
  // },
  getReportPersonDemographicsOverTimeError: state => state.rptpersonDemographicsOverTimeError,
  getReportPersonDemographicsOverTimeUnconfirmedError: state => state.rptpersonDemographicsOverTimeUnconfirmedError,
  getReportPersonDemographicsOverTimeConfirmedError: state => state.rptpersonDemographicsOverTimeConfirmedError,
  getReportCseitCountsByTimeError: state => state.rptcseitCountsByTimeError,
  getReportCseitCountsByDemographicError: state => state.rptcseitCountsByDemographicError,
  getReportCseitDemographicsByTimeError: state => state.rptcseitDemographicsByTimeError,
  getReportCseitDemographicsOverTimeNoConcernError: state => state.rptcseitDemographicsOverTimeNoConcernError,
  getReportCseitDemographicsOverTimePossibleConcernError: state => state.rptcseitDemographicsOverTimePossibleConcernError,
  getReportCseitDemographicsOverTimeClearConcernError: state => state.rptcseitDemographicsOverTimeClearConcernError,
  getReportAssessmentCountsByTimeError: state => state.rptassessmentCountsByTimeError,
  getReportAssessmentByDemographicError: state => state.rptassessmentByDemographicError,
  getReportAssessmentDemographicsByTimeError: state => state.rptassessmentDemographicsByTimeError,
  getReportAssessmentDemographicsOverTimeNoInfoError: state => state.rptassessmentDemographicsOverTimeNoInfoError,
  getReportAssessmentDemographicsOverTimePossibleError: state => state.rptassessmentDemographicsOverTimePossibleError,
  getReportAssessmentIndicatorsError: state => state.rptassessmentIndicatorsError,
  getReportCseitIndicatorsError: state => state.rptcseitIndicatorsError,
  getLocationFilterOptions: state => state.locationFilterOptions,
  getScreeningsByOrg: state => state.screeningsByOrg,
  getScreeningsByOrgError: state => state.screeningsByOrgError,
  getLaborScreeningsByOrg: state => state.laborScreeningsByOrg,
  getLaborScreeningsByOrgError: state => state.laborScreeningsByOrgError,
  getRptLaborScreeningCountsByTime: state => state.rptLaborScreeningCountsByTime,
  getRptLaborScreeningCountsByTimeError: state => state.rptLaborScreeningCountsByTimeError,
  getRptLaborScreeningCountsByDemographic: state => state.rptLaborScreeningCountsByDemographic,
  getRptLaborScreeningCountsByDemographicError: state => state.rptLaborScreeningCountsByDemographicError,
  getRptLaborScreeningDemographicsByTime: state => state.rptLaborScreeningDemographicsByTime,
  getRptLaborScreeningsDemographicsByTimeNotEnoughInfo: state => state.rptLaborScreeningDemographicsByTimeNotEnoughInfo,
  getRptLaborScreeningsDemographicsByTimeVulnerable: state => state.rptLaborScreeningDemographicsByTimeVulnerable,
  getRptLaborScreeningsDemographicsByTimeHighlyVulnerable: state => state.rptLaborScreeningDemographicsByTimeHighlyVulnerable,
  getRptLaborScreeningDemographicsByTimeError: state => state.rptLaborScreeningDemographicsByTimeError
}

// actions
const actions = {
  async getReportPersonCountsByDemographic ({ commit, state, rootState }, payload) {
    let response = await reports.getReportPersonCountsByDemographic(payload)
    response = response.body

    if (response === 'No permissible person records') {
      commit('setReportPersonCountsByDemographicError', true)
    } else {
      commit('setReportPersonCountsByDemographic', response)
      commit('setReportPersonCountsByDemographicError', false)
    }
  },
  async getReportGeneralCounts ({ commit, state, rootState }, payload) {
    // payload = mergeUserContext(payload, rootState)
    let response = await reports.getReportGeneralCounts(payload)
    response = response.body

    commit('setReportGeneralCounts', response)
  },
  async getReportPersonCountsByTime ({ commit, state, rootState }, payload) {
    // payload = mergeUserContext(payload, rootState)
    let response = await reports.getReportPersonCountsByTime(payload)
    response = response.body

    if (response === 'No permissible person records') {
      commit('setReportPersonCountsByTimeError', true)
    } else {
      commit('setReportPersonCountsByTime', response)
      commit('setReportPersonCountsByTimeError', false)
    }
  },
  async getReportPersonDemographicsOverTime ({ commit, state, rootState }, payload) {
    let response = await reports.getReportPersonDemographicsOverTime(payload)
    response = response.body

    if (response === 'No permissible person records') {
      commit('setReportPersonDemographicsOverTimeError', true)
    } else {
      commit('setReportPersonDemographicsOverTime', response)
      commit('setReportPersonDemographicsOverTimeError', false)
    }
  },
  async getAllUsers ({ commit, state, rootState }, payload) {
    let response = await reports.getAllUsers(payload)
    response = response.body

    if (response === 'No permissible person records') {
      commit('setAllUsersError', true)
    } else {
      commit('setAllUsers', response)
      commit('setAllUsersError', false)
    }
  },
  async getAllOrgs ({ commit, state, rootState }, payload) {
    let response = await reports.getAllOrgs(payload)
    response = response.body

    if (response === 'No permissible person records') {
      commit('setAllOrgsError', true)
    } else {
      commit('setAllOrgs', response)
      commit('setAllOrgsError', false)
    }
  },
  async getGroups ({ commit, state, rootState }, payload) {
    let response = await reports.getGroups(payload)
    response = response.body

    if (response === 'No permissible person records') {
      commit('setGroupsError', true)
    } else {
      commit('setGroups', response)
      commit('setGroupsError', false)
    }
  },
  async getAllLogs ({ commit, state, rootState }, payload) {
    let response = await reports.getAllLogs(payload)
    response = response.body

    if (response === 'No permissible person records') {
      commit('setAllLogsError', true)
    } else {
      commit('setAllLogs', response)
      commit('setAllLogsError', false)
    }
  },
  async getAllScreenings ({ commit, state, rootState }, payload) {
    let response = await reports.getAllScreenings(payload)
    response = response.body

    if (response === 'No permissible person records') {
      commit('setAllScreeningsError', true)
    } else {
      console.log('all screenings')
      commit('setAllScreenings', response)
      commit('setAllScreeningsError', false)
    }
  },
  // Updates
  async getReportAssessmentCountsByTime ({ commit, state, rootState }, payload) {
    let response = await reports.getReportAssessmentCountsByTime(payload)
    response = response.body
    console.log(response.body)

    if (response === 'No permissible person records') {
      commit('setReportCseitCountsByTimeError', true)
    } else {
      commit('setReportAssessmentCountsByTime', response)
      commit('setReportCseitCountsByTimeError', false)
    }
  },
  async getReportCseitCountsByTime ({ commit, state, rootState }, payload) {
    let response = await reports.getReportCseitCountsByTime(payload)
    response = response.body
    console.log(response.body)

    if (response === 'No permissible person records') {
      commit('setReportCseitCountsByTimeError', true)
    } else {
      commit('setReportCseitCountsByTime', response)
      commit('setReportCseitCountsByTimeError', false)
    }
  },
  async getReportAssessmentIndicators ({ commit, state, rootState }, payload) {
    let response = await reports.getReportAssessmentIndicators(payload)
    response = response.body
    console.log(response.body)

    if (response === 'No permissible person records') {
      commit('setReportAssessmentIndicatorsError', true)
    } else {
      commit('setReportAssessmentIndicators', response)
      commit('setReportAssessmentIndicatorsError', false)
    }
  },
  async getReportPersonDemographicsOverTimeUnconfirmed ({ commit, state, rootState }, payload) {
    let response = await reports.getReportPersonDemographicsOverTime(payload)
    response = response.body
    console.log(response.body)

    if (response === 'No permissible person records') {
      commit('setReportPersonDemographicsOverTimeUnconfirmedError', true)
    } else {
      commit('setReportPersonDemographicsOverTimeUnconfirmed', response)
      commit('setReportPersonDemographicsOverTimeUnconfirmedError', false)
    }
  },
  async getReportPersonDemographicsOverTimeConfirmed ({ commit, state, rootState }, payload) {
    let response = await reports.getReportPersonDemographicsOverTime(payload)
    response = response.body
    console.log(response.body)

    if (response === 'No permissible person records') {
      commit('setReportPersonDemographicsOverTimeConfirmedError', true)
    } else {
      commit('setReportPersonDemographicsOverTimeConfirmed', response)
      commit('setReportPersonDemographicsOverTimeConfirmedError', false)
    }
  },
  async getReportAssessmentCountsByDemographic ({ commit, state, rootState }, payload) {
    let response = await reports.getReportAssessmentCountsByDemographic(payload)
    response = response.body

    if (response === 'No permissible person records') {
      commit('setReportAssessmentByDemographicError', true)
    } else {
      commit('setReportAssessmentCountsByDemographic', response)
      commit('setReportAssessmentByDemographicError', false)
    }
  },
  async getReportCseitCountsByDemographic ({ commit, state, rootState }, payload) {
    let response = await reports.getReportCseitCountsByDemographic(payload)
    response = response.body
    console.log(response.body)

    if (response === 'No permissible person records') {
      commit('setReportCseitCountsByDemographicError', true)
    } else {
      commit('setReportCseitCountsByDemographic', response)
      commit('setReportCseitCountsByDemographicError', false)
    }
  },
  async getReportAssessmentDemographicsByTime ({ commit, state, rootState }, payload) {
    let response = await reports.getReportAssessmentDemographicsOverTime(payload)
    response = response.body
    console.log(response.body)

    if (response === 'No permissible person records') {
      commit('setReportAssessmentDemographicsByTimeError', true)
    } else {
      commit('setReportAssessmentDemographicsByTime', response)
      commit('setReportAssessmentDemographicsByTimeError', false)
    }
  },
  async getReportAssessmentDemographicsByTimeNoInfoVictims ({ commit, state, rootState }, payload) {
    let response = await reports.getReportAssessmentDemographicsOverTime(payload)
    response = response.body
    console.log(response.body)

    if (response === 'No permissible person records') {
      commit('setReportAssessmentDemographicsByTimeNoInfoVictimsError', true)
    } else {
      commit('setReportAssessmentDemographicsByTimeNoInfoVictims', response)
      commit('setReportAssessmentDemographicsByTimeNoInfoVictimsError', false)
    }
  },
  async getReportAssessmentDemographicsByTimePossibleVictims ({ commit, state, rootState }, payload) {
    let response = await reports.getReportAssessmentDemographicsOverTime(payload)
    response = response.body
    console.log(response.body)

    if (response === 'No permissible person records') {
      commit('setReportAssessmentDemographicsByTimePossibleVictimsError', true)
    } else {
      commit('setReportAssessmentDemographicsByTimePossibleVictims', response)
      commit('setReportAssessmentDemographicsByTimePossibleVictimsError', false)
    }
  },
  async getReportCseitDemographicsByTime ({ commit, state, rootState }, payload) {
    let response = await reports.getReportCseitDemographicsByTime(payload)
    response = response.body
    console.log(response.body)

    if (response === 'No permissible person records') {
      commit('setReportCseitDemographicsByTimeError', true)
    } else {
      commit('setReportCseitDemographicsByTime', response)
      commit('setReportCseitDemographicsByTimeError', false)
    }
  },
  async getReportCseitDemographicsByTimeNoConcern ({ commit, state, rootState }, payload) {
    let response = await reports.getReportCseitDemographicsByTime(payload)
    response = response.body
    console.log(response.body)

    if (response === 'No permissible person records') {
      commit('setReportCseitDemographicsByTimeNoConcernError', true)
    } else {
      commit('setReportCseitDemographicsByTimeNoConcern', response)
      commit('setReportCseitDemographicsByTimeNoConcernError', false)
    }
  },
  async getReportCseitDemographicsByTimePossibleConcern ({ commit, state, rootState }, payload) {
    let response = await reports.getReportCseitDemographicsByTime(payload)
    response = response.body
    console.log(response.body)

    if (response === 'No permissible person records') {
      commit('setReportCseitDemographicsByTimePossibleConcernError', true)
    } else {
      commit('setReportCseitDemographicsByTimePossibleConcern', response)
      commit('setReportCseitDemographicsByTimePossibleConcernError', false)
    }
  },
  async getReportCseitDemographicsByTimeClearConcern ({ commit, state, rootState }, payload) {
    let response = await reports.getReportCseitDemographicsByTime(payload)
    response = response.body
    console.log(response.body)

    if (response === 'No permissible person records') {
      commit('setReportCseitDemographicsByTimeClearConcernError', true)
    } else {
      commit('setReportCseitDemographicsByTimeClearConcern', response)
      commit('setReportCseitDemographicsByTimeClearConcernError', false)
    }
  },
  async getReportCseitIndicators ({ commit, state, rootState }, payload) {
    let response = await reports.getReportCseitIndicators(payload)
    response = response.body
    console.log(response.body)

    if (response === 'No permissible person records') {
      commit('setReportCseitIndicatorsError', true)
    } else {
      commit('setReportCseitIndicators', response)
      commit('setReportCseitIndicatorsError', false)
    }
  },
  async getScreeningsByOrg ({ commit, state, rootState }, payload) {
    let response = await reports.getScreeningsByOrg(payload)
    response = response.body

    if (response === 'No permissible cseit records') {
      commit('setScreeningsByOrgError', true)
    } else {
      commit('setScreeningsByOrg', response)
      console.log('screenings by org', response)
      commit('setScreeningsByOrgError', false)
    }
  },
  async getLaborScreeningsByOrg ({ commit }, payload) {
    try {
      const response = await reports.getLaborScreeningsByOrg(payload)
      if (!response.ok) {
        throw new Error()
      }
      commit('setLaborScreeningsByOrg', response.body)
      commit('setLaborScreeningsByOrgError', false)
    } catch (error) {
      commit('setLaborScreeningsByOrgError', true)
    }
  },
  async getReportLaborScreeningCountsByTime ({ commit }, payload) {
    try {
      const response = await reports.getReportLaborScreeningCountsByTime(payload)
      if (!response.ok) {
        throw new Error()
      }

      console.log('response.body', response.body)
      commit('setRptLaborScreeningCountsByTime', response.body)
      commit('setRptLaborScreeningCountsByTimeError', false)
    } catch (error) {
      commit('setRptLaborScreeningCountsByTimeError', true)
    }
  },
  async getReportLaborScreeningCountsByDemographic ({ commit }, payload) {
    try {
      const response = await reports.getReportLaborScreeningCountsByDemographic(payload)
      if (!response.ok) {
        throw new Error()
      }
      commit('setRptLaborScreeningCountsByDemographic', response.body)
      commit('setRptLaborScreeningCountsByDemographicError', false)
    } catch (error) {
      commit('setRptLaborScreeningCountsByDemographicError', true)
    }
  },
  async getReportLaborScreeningDemographicsByTime ({ commit }, payload) {
    try {
      const response = await reports.getReportLaborScreeningDemographicsByTime(payload)
      if (!response.ok) {
        throw new Error()
      }

      console.log('getReportLaborScreeningDemographicsByTime', response.body)
      commit('setRptLaborScreeningDemographicsByTime', response.body)
      commit('setRptLaborScreeningDemographicsByTimeError', false)
    } catch (error) {
      commit('setRptLaborScreeningDemographicsByTimeError', true)
    }
  },
  async getReportLaborScreeningIndicators ({ commit }, payload) {
    try {
      const response = await reports.getReportLaborScreeningIndicators(payload)
      if (!response.ok) {
        throw new Error()
      }
      console.log('getReportLaborScreeningIndicators', response.body)
      commit('setRptLaborScreeningIndicators', response.body)
      commit('setRptLaborScreeningIndicatorsError', false)
    } catch (error) {
      commit('setRptLaborScreeningIndicatorsError', true)
    }
  }
}

// mutations
const mutations = {

  setReportPersonCountsByDemographic (state, payload) {
    state.rptPersonCountsByDemographic = payload
  },

  setReportPersonCountsByDemographicError (state, payload) {
    state.rptPersonCountsByDemographicError = payload
  },

  setReportGeneralCounts (state, payload) {
    state.rptgeneralCounts = payload
  },

  setReportPersonCountsByTime (state, payload) {
    state.rptpersonCountsByTime = payload
  },

  setReportPersonDemographicsOverTime (state, payload) {
    state.rptpersonDemographicsOverTime = payload
  },

  setAllUsers (state, payload) {
    state.allUsers = payload
  },

  setAllUsersError (state, payload) {
    state.allUsersError = payload
  },

  setAllOrgs (state, payload) {
    state.allOrgs = payload
  },

  setAllOrgsError (state, payload) {
    state.allOrgsError = payload
  },

  setGroups (state, payload) {
    state.allGroups = payload
  },

  setGroupsError (state, payload) {
    state.allGroupsError = payload
  },

  setAllLogs (state, payload) {
    state.allLogs = payload
  },

  setAllLogsError (state, payload) {
    state.allLogsError = payload
  },

  setAllScreenings (state, payload) {
    state.allScreenings = payload
  },

  setAllScreeningsError (state, payload) {
    state.allScreeningsError = payload
  },

  setReportAssessmentCountsByTime (state, payload) {
    state.rptassessmentCountsByTime = payload
  },

  setReportCseitCountsByTime (state, payload) {
    state.rptcseitCountsByTime = payload
  },

  setReportAssessmentIndicators (state, payload) {
    state.rptassessmentIndicators = payload
  },

  setReportPersonDemographicsOverTimeUnconfirmed (state, payload) {
    state.rptPersonDemographicsOverTimeUnconfirmed = payload
  },

  setReportPersonDemographicsOverTimeConfirmed (state, payload) {
    state.rptPersonDemographicsOverTimeConfirmed = payload
  },

  setReportAssessmentCountsByDemographic (state, payload) {
    state.rptassessmentCountsByDemographic = payload
  },

  setReportCseitCountsByDemographic (state, payload) {
    state.rptcseitCountsByDemographic = payload
  },

  setReportAssessmentDemographicsByTime (state, payload) {
    state.rptassessmentDemographicsByTime = payload
  },

  setReportAssessmentDemographicsByTimeNoInfoVictims (state, payload) {
    state.rptassessmentDemographicsByTimeNoInfoVictims = payload
  },

  setReportAssessmentDemographicsByTimePossibleVictims (state, payload) {
    state.rptassessmentDemographicsByTimePossibleVictims = payload
  },

  setReportCseitDemographicsByTime (state, payload) {
    state.rptcseitDemographicsByTime = payload
  },

  setReportCseitDemographicsByTimeNoConcern (state, payload) {
    state.rptcseitDemographicsByTimeNoConcern = payload
  },

  setReportCseitDemographicsByTimePossibleConcern (state, payload) {
    state.rptcseitDemographicsByTimePossibleConcern = payload
  },

  setReportCseitDemographicsByTimeClearConcern (state, payload) {
    state.rptcseitDemographicsByTimeClearConcern = payload
  },

  setRptLaborScreeningDemographicsByTime (state, payload) {
    state.rptLaborScreeningDemographicsByTime = payload
  },

  setRptLaborScreeningDemographicsByTimeNotEnoughInfo (state, payload) {
    state.rptLaborScreeningDemographicsByTimeNotEnoughInfo = payload
  },

  setRptLaborScreeningDemographicsByTimeVulnerable (state, payload) {
    state.rptLaborScreeningDemographicsByTimeVulnerable = payload
  },

  setRptLaborScreeningDemographicsByTimeHighlyVulnerable (state, payload) {
    state.rptLaborScreeningDemographicsByTimeHighlyVulnerable = payload
  },

  setRptLaborScreeningDemographicsByTimeError (state, payload) {
    state.rptLaborScreeningDemographicsByTimeError = payload
  },

  setLaborScreeningsByOrg (state, payload) {
    state.laborScreeningsByOrg = payload
  },

  setLaborScreeningsByOrgError (state, payload) {
    state.laborScreeningsByOrgError = payload
  },

  setReportCseitIndicators (state, payload) {
    state.rptcseitIndicators = payload
  },

  setReportPersonCountsByTimeError (state, payload) {
    state.rptpersonCountsByTimeError = payload
  },

  setReportPersonDemographicsOverTimeError (state, payload) {
    state.rptpersonDemographicsOverTimeError = payload
  },

  setReportPersonDemographicsOverTimeUnconfirmedError (state, payload) {
    state.rptpersonDemographicsOverTimeUnconfirmedError = payload
  },

  setReportPersonDemographicsOverTimeConfirmedError (state, payload) {
    state.personDemographicsOverTimeConfirmedError = payload
  },

  setReportCseitCountsByTimeError (state, payload) {
    state.rptcseitCountsByTimeError = payload
  },

  setReportCseitCountsByDemographicError (state, payload) {
    state.rptcseitCountsByDemographicError = payload
  },

  setReportCseitDemographicsByTimeError (state, payload) {
    state.rptcseitDemographicsByTimeError = payload
  },

  setReportCseitDemographicsByTimeNoConcernError (state, payload) {
    state.rptcseitDemographicsOverTimeNoConcernError = payload
  },

  setReportCseitDemographicsByTimePossibleConcernError (state, payload) {
    state.rptcseitDemographicsOverTimePossibleConcernError = payload
  },

  setReportCseitDemographicsByTimeClearConcernError (state, payload) {
    state.rptcseitDemographicsOverTimeClearConcernError = payload
  },

  setReportAssessmentCountsByTimeError (state, payload) {
    state.rptassessmentCountsByTimeError = payload
  },

  setReportAssessmentByDemographicError (state, payload) {
    state.rptassessmentByDemographicError = payload
  },

  setReportAssessmentDemographicsByTimeError (state, payload) {
    state.rptassessmentDemographicsByTimeError = payload
  },

  setReportAssessmentDemographicsByTimeNoInfoVictimsError (state, payload) {
    state.rptassessmentDemographicsOverTimeNoInfoError = payload
  },

  setReportAssessmentDemographicsByTimePossibleVictimsError (state, payload) {
    state.rptassessmentDemographicsOverTimePossibleError = payload
  },

  setReportAssessmentIndicatorsError (state, payload) {
    state.rptassessmentIndicatorsError = payload
  },

  setReportCseitIndicatorsError (state, payload) {
    state.rptcseitIndicatorsError = payload
  },

  setScreeningsByOrgError (state, payload) {
    state.screeningsByOrgError = payload
  },

  setScreeningsByOrg (state, payload) {
    state.screeningsByOrg = payload
  },

  setRptLaborScreeningCountsByTime (state, payload) {
    state.rptLaborScreeningCountsByTime = payload
  },

  setRptLaborScreeningCountsByTimeError (state, payload) {
    state.rptLaborScreeningCountsByTimeError = payload
  },

  setRptLaborScreeningCountsByDemographic (state, payload) {
    state.rptLaborScreeningCountsByDemographic = payload
  },

  setRptLaborScreeningCountsByDemographicError (state, payload) {
    state.rptLaborScreeningCountsByDemographicError = payload
  },

  setRptLaborScreeningIndicators (state, payload) {
    state.rptLaborScreeningIndicators = payload
  },

  setRptLaborScreeningIndicatorsError (state, payload) {
    state.rptLaborScreeningIndicatorsError = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/reports.js